import './css/bootstrap.min.css';
import './css/bootstrap-theme.min.css';
import './css/style.css';
import './css/custom.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { HelmetProvider } from 'react-helmet-async';;

ReactDOM.render(
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_SERVERKEY}>
      <HelmetProvider>
        <App />
      </HelmetProvider>  
    </GoogleReCaptchaProvider>,
  document.getElementById('root')
);
